module.exports = __webpack_public_path__ + "img/person-pinball.cd44aedc.svg";